import { QueryClient, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { AxiosWrapper } from 'services/AxiosWrapper';
import { ItineraryManagerApiService } from 'services/ItineraryManagerApi';
import { ItineraryTypes } from './types';

export const useItineraryQueries = (
  itineraryManagerApi: ItineraryManagerApiService<AxiosWrapper<AxiosInstance>>,
  bookingUuid: string,
  version: string
) => {
  return {
    getItineraryView: useQuery({
      queryKey: ['getItineraryView', bookingUuid, version],
      queryFn: async () => {
        if (!bookingUuid || !version) {
          return;
        }
        return itineraryManagerApi.getItineraryView(bookingUuid, version);
      },
    }),
  };
};
